
cafm.hd.checklist = {

    sendAnswers: true,
    sendQuestions: true,
    activeCommentTextArea: null,

    get currentForm() {

        let form = $(".checklistForm:visible");
        if (isMobile && form.length < 1) {
            if (cafm.hd.checklist.helpers.isActiveChecklistForAsset()) {
                form = cafm.views.getActionForm().find(".asset-checklist-target > .checklistForm");
            }
            else {
                form = $(`#${cafm.res.consts.ElementId_FormWidget} > .k-item[aria-expanded=true] .checklistForm`);
            }
        }
        return form;
    },
    get currentChecklist() {
        return cafm.hd.checklist.currentForm.getViewModel();
    },
    getWorkOrderActionChecklists: function () {
        /// <summary>Get the current work order action checklists</summary>
        /// <returns type="Array">Returns array of action checklists</returns>
        
        return cafm.hd.getWorkOrderChildList('ActionChecklists');
    },
    getWorkOrderRiskAssessmentChecklists: function () {
        /// <summary>Get the current work order risk checklists</summary>
        /// <returns type="Array">Returns array of risk checklists</returns>
        
        return cafm.hd.getWorkOrderChildList('RiskAssessmentChecklists');
    },
    render: function (checklist, element, mode, isAssetChecklist) {
        /// <summary>Function to render a checklist</summary>
        /// <param name="checklist" type="kendo.Observable">The answchecklister object to render</param>
        /// <param name="element" type="$">The query element to render the checklist inside</param>
        
        if (!checklist) throw new Error('checklist is null');
        if (!element) throw new Error('element is null');

        // set the status label
        cafm.hd.checklist.helpers.setChecklistStatusDescription(checklist);
        cafm.hd.checklist.helpers.setChecklistCompletionStage(checklist);

        var listContainer = element.closest('.' + cafm.res.consts.CssClass_ListSection),
            formContainer = listContainer.parent().find('.checklistForm'),
            removeCommentLinks = function () {

                formContainer.find('li:not(.hasComment) .commentLink,.commentEditLink').remove();
            };

        if (isAssetChecklist) {
            element.append(formContainer);
        }

        // code safety to avoid JS template binding errors
        if (!checklist.Questions) checklist.Questions = [];
        if (!checklist.Documents) checklist.Documents = [];

        // back to checklists handler for binding
        checklist.backToChecklists = function () {

            // allow the checklist answer to sync before going back, as list binding is client side now we need to wait for the wo to sync
            var me = this;
            cafm.util.callFunctionAsync({
                func: () => {
                    cafm.util.doWhen(() => {
                        if (isAssetChecklist) {                            
                            let assetChecklist = cafm.assets.getWorkOrderAssetChecklist(checklist.ID);
                            me.unbind('change');
                            cafm.hd.checklist.render(assetChecklist, element, mode, isAssetChecklist);
                            cafm.views.closeActionWindow();
                        }
                        else {
                            listContainer.show();
                            formContainer.hide();
                            me.unbind('change');
                            // refresh the data source
                            listContainer.find('.cGrd,.cLv').refreshDataSource();
                        }
                    }, () => {
                        return !cafm.hd.syncInProgress;
                    })
                },
                timeout: 75
            })
        }

        // disable completed checkbox if marked as failed or completed
        $('.iscompleted-field', formContainer).setCheckboxDisabled(checklist.IsCompleted || checklist.IsFailed);

        // show / hide the Is Failed checkbox
        if (checklist.IsCompleted) {

            $('.isfailed-field', formContainer).hide();
        }
        else {
            
            $('.isfailed-field', formContainer).show();

            // [CAFM-5486] historic engineer should not be able to fail/reopen a checklist
            if (cafm.hd.helpers.isHistoricTradePersonForWorkOrder(cafm.hd.workOrder) || (cafm.hd.workOrder.IsLocked && cafm.hd.helpers.isContractor())) $('.isfailed-field', formContainer).setCheckboxDisabled(true);
        }

        // create html formatted checklist comments 
        if (checklist.Comments) {

            checklist.FormattedComments = cafm.util.toUlString(cafm.util.encodeHtml(checklist.Comments));
        }

        // format questions, ensuring answer values and move secondary questions
        cafm.hd.checklist.formatQuestions(checklist);

        // attach secondary question paths function
        checklist.openSecondaryQuestionPaths = cafm.hd.checklist.openSecondaryQuestionPaths;

        // bind the checklist to the form
        formContainer.bindViewModel(checklist);
        
        // now get the observable view model
        checklist = formContainer.getViewModel();

        // if completed, failed or not a trade person on the work order
        if (checklist.IsCompleted || checklist.IsFailed || !cafm.hd.workOrder.CanAnswerChecklists) {

            // disable all controls
            formContainer.find('.cLvWrap input,textarea').prop('disabled', true);

            // remove comment links
            removeCommentLinks();

            if (!checklist.IsCompleted) {
                checklist.unbind('change');
                // setup changed handler only when not completed
                checklist.bind('change', cafm.hd.checklist.handlers.checklistChanged);
            }
        }
        else {

            // attach comment handlers
            if (checklist.AllowComments) {

                formContainer.off('click.cafm1').on('click.cafm1', '.commentLink', cafm.hd.checklist.handlers.editComment);
                formContainer.off('click.cafm2').on('click.cafm2', '.commentEditLink', cafm.hd.checklist.handlers.editComment);
                formContainer.off('blur.cafm').on('blur.cafm', '.commentTextArea textarea', cafm.hd.checklist.handlers.endEditComment);
                formContainer.off('change.cafm1').on('change.cafm1', '.commentTextArea', cafm.hd.checklist.handlers.commentChanged);
            }
            checklist.unbind('change');
            // setup changed handler
            checklist.bind('change', cafm.hd.checklist.handlers.checklistChanged);
        };
        
        // if mobile or not supported use kendo control
        if (!isMobile || !cafm.browsers.supportsInput('date') || cafm.browsers.isMobileOnDesktop()) {

            formContainer.find('[data-fieldtype="{0}"]'.format(cafm.enums.InputType.Date)).kendoDatePicker();
        }

        // if mobile or not supported use kendo control
        if (!isMobile || !cafm.browsers.supportsInput('datetime-local') || cafm.browsers.isMobileOnDesktop()) {

            formContainer.find('[data-fieldtype="{0}"]'.format(cafm.enums.InputType.DateTime)).kendoDateTimePicker();
        }

        formContainer.find('[data-fieldtype="{0}"]'.format(cafm.enums.InputType.Time)).kendoTimePicker();

        formContainer.find('[data-fieldtype="{0}"]:not([data-decimals])'.format(cafm.enums.InputType.Numeric)).kendoNumericTextBox();

        formContainer.find('[data-fieldtype="{0}"][data-decimals]'.format(cafm.enums.InputType.Numeric)).each(function (i, el) {
            var input = $(el);
            input.kendoNumericTextBox({
                decimals: input.data('decimals')
            });
        });

        // clear this to ensure correct state
        cafm.hd.checklist.activeCommentTextArea = null;

        // hide the checklist list
        if (isAssetChecklist) formContainer.find(".checklistBack").hide();
        else listContainer.hide();

        // now show the form
        formContainer.show();

        // call next bit of logic asynchronously so other logic can continue
        cafm.util.callFunctionAsync({

            func: function () {

                // if mode equals read only
                if (mode === cafm.enums.ChecklistFormMode.Admin) {

                    // remove comment links
                    removeCommentLinks();

                    formContainer.attr('id', 'admin-checklist-form');

                    var form = formContainer.find('.itemList');
                    form.addClass('read-only');

                    form.find('input, textarea').each(function (i, text) {

                        if (text.tagName == 'TEXTAREA') text.style.height = text.scrollHeight + 'px';

                        var input = $(text);
                        if (!input.val()) {

                            input.val(cafm.res.str.TextNotSet);
                        }
                    })

                    form.find('input[type="text"],textarea').prop('readonly', true);
                    form.find('input[type="text"],textarea').keydown(function () { return false; });
                    form.find('input[type="radio"]').prop('disabled', true);
                    form.find('.chk').setCheckboxDisabled(true);

                    if (!checklist.IsFailed) formContainer.find('.isfailed-field').hide();
                }
                else {

                    formContainer.removeClass('read-only');
                    formContainer.find('.iscompleted-field').remove();
                }

                // set field label widths
                formContainer.find('.checklist-fields').setLabelWidths({

                    container: formContainer,
                    labelSelector: '.info-label',
                    afterSetLabelWidth: function () {

                        // open secondary paths
                        checklist.openSecondaryQuestionPaths();

                        // comment text fields - these have to be visible by default to calculate the label widths
                        formContainer.find('.commentTextArea').hide();
                       
                        // hide all comment wrappers where there is no comment
                        formContainer.find('[data-id]').each(function (e, el) {

                            var item = $(el), question = cafm.hd.checklist.helpers.getChecklistQuestion(checklist, item.data('id'));

                            if (question && !question.HasComment) {

                                formContainer.find('[data-id="{0}"]'.format(question.ID)).find('> .checklist-fields > .commentWrapper').hide();
                            }
                        });
                    }
                });
            }
        });
    },
    formatQuestions: function (checklist) {
        /// <summary>Function to move secondary questions onto parent questions, this done for binding</summary>
        /// <param name="checklist" type="kendo.Observable">The checklist object</param>

        let formatQuestion = function (question) {

            var secondary = [];

            // format the comments into formatted comments for display as HTML with line breaks
            if (question.Comments) {

                question.FormattedComments = cafm.util.toSafeHtml(question.Comments);
                question.HasComment = true;
            }
            else {

                question.FormattedComments = '';
                question.HasComment = false;
            }

            if (cafm.util.hasItem(question.Answers)) {

                var qt = cafm.enums.QuestionDataType;
                question.Answers.forEach(function (answer) {

                    // ensure date values are converted to proper date instances
                    if (answer.Value && cafm.enums.isSingleEnumValue(question.DataType, [qt.Date, qt.DateTime, qt.Time])) {

                        answer.Value = cafm.util.ensureDate(answer.Value);
                    }

                    // ensure radio values are the answer guids if true - required for html binding
                    if (answer.Value === true && question.DataType === qt.RadioButton) {

                        answer.Value = answer.ID;
                    }

                    // format secondary question if there is one
                    if (answer.SecondaryQuestion) {

                        var sq = answer.SecondaryQuestion;

                        // set secondary question ID on the answer
                        answer.SecondaryQuestionID = sq.ID;

                        // now push onto the array
                        secondary.push(sq);

                        // and set secondary questions onto the question as required for ui binding
                        sq.SecondaryQuestions = formatQuestion(sq);
                    }
                });
            }

            return secondary;
        }

        checklist.Questions.forEach(function (question) {

            question.SecondaryQuestions = formatQuestion(question);
        });
    },
    openSecondaryQuestionPaths: function () {

        var openPath = function (question) {

            question.Answers.forEach(function (answer) {

                if (answer.SecondaryQuestionID) {

                    // set secondary question ID as attr on the answer control
                    var answerInput = $('#{0}'.format(answer.ID));

                    // if the answer input is checked
                    if (answerInput.is(':checked')) {

                        // hide all secondary questiosn under the question
                        var sqContainer = $('li[data-id="{0}"]'.format(question.ID)).find('> .secondary-questions');
                        sqContainer.children().hide();
                        sqContainer.show();

                        $('[data-id="{0}"]'.format(answer.SecondaryQuestionID)).show()

                        if (answer.SecondaryQuestion) {

                            openPath(answer.SecondaryQuestion)
                        }
                    }
                }
            });
        }

        // hide secondary questions first, ready to expand only the opened paths
        cafm.hd.checklist.currentForm.find('.secondary-questions').hide();

        // now go through each question and open up secondary paths if they've been answered
        this.Questions.forEach(function (question) {

            if (cafm.util.hasItem(question.Answers)) {

                openPath(question);
            }
        })
    },
    actions: {

        completeChecklist: function (checklist) {
            /// <summary>Function to complete a checklist on behalf of the assignee</summary>
            /// <param name="args" type="Object">Event args object</param>
            
            // check for these ids that come off elements
            if (!checklist) return;

            var chk = $('#admin-checklist-form .iscompleted-field');

            chk.setCheckboxDisabled(true);

            cafm.hd.addSyncAction(function (syncId) {

                cafm.hd.callSyncAction({
                    url: cafm.url.api('WorkOrder/CompleteChecklist'),
                    values: {
                        ChecklistID: checklist.ID,
                        WorkOrderID: cafm.actions.getObjectInContextId()
                    },
                    syncId: syncId,
                    preventDirty: isMobile,
                    success: function () {

                        chk.setCheckboxDisabled(true);
                    },
                    error: function () {

                        chk.setChecked(false);
                        chk.setCheckboxDisabled(false);
                    }
                });
            }, checklist.ID);
        }
    },    
    answer: {

        render: function (answer) {
            /// <summary>Function to render a checklist answer</summary>
            /// <param name="answer" type="kendo.Observable">The answer object to render</param>
            /// <returns type="String">Returns HTML string</param>

            var question = answer.parent().parent(),
                qt = cafm.enums.QuestionDataType,
                tagName,
                atts;
            
            // set tagName and atts for each question type
            switch (question.DataType) {

                case qt.RadioButton:

                    tagName = 'input';
                    atts = {
                        'data-bind': 'checked: Value',
                        type: 'radio',
                        name: question.ID,
                        value: answer.ID,
                        'class': 'k-radio'
                    }
                    break;

                case qt.FreeText:

                    tagName = 'textarea';
                    atts = {
                        'class': 'cfControl cfTextArea'
                    }
                    break;

                case qt.Date:
                case qt.DateTime:

                    var isDateType = question.DataType == qt.Date,
                        format = isDateType ? 'd' : 'g',
                        inputType = isDateType ? 'date' : 'datetime-local',
                        fieldType = isDateType ? cafm.enums.InputType.Date : cafm.enums.InputType.DateTime;

                    tagName = 'input';
                    atts = {
                        'data-format': format,
                        'data-fieldtype': fieldType
                    }

                    // if mobile and supported use native control
                    if (isMobile && cafm.browsers.supportsInput(inputType) && !cafm.browsers.isMobileOnDesktop()) {

                        atts.type = inputType;
                        atts['data-bind'] = 'dateValue: Value';
                    }

                    break;

                case qt.Time:

                    tagName = 'input';
                    atts = {
                        'data-fieldtype': cafm.enums.InputType.Time
                    }
                    break;

                case qt.Integer:

                    tagName = 'input';
                    atts = {
                        'data-fieldtype': cafm.enums.InputType.Numeric,
                        'data-decimals': 0,
                        'data-format': 'n0'
                    }
                    break;

                case qt.Decimal:

                    tagName = 'input';
                    atts = {
                        'data-fieldtype': cafm.enums.InputType.Numeric,
                        'data-decimals': 5,
                        'data-format': '#.#####'
                    }
                    break;

                default:

                    // checkbox is default

                    tagName = 'input';
                    atts = {

                        'data-bind': 'checked: Value',
                        type: 'checkbox',
                        'class': 'k-checkbox'
                    }
            }

            // set id, class, data-bind for all 
            atts.id = answer.ID;
            if (!atts.class) atts.class = 'cfControl';
            if (!atts['data-bind']) atts['data-bind'] = 'value: Value';

            // create the control
            var control = $('<{0}/>'.format(tagName), atts);

            // wrap the control in a field element and create label
            var wrap = $('<div class="cfField"></div>').append(control),
                label = $('<label/>', {
                    'class': 'info-label cfLabel'
                });

            // set correct description, use answer over question
            // if there is only one answer and no ansswer description use the question description
            if (answer.Label) {

                label.html(cafm.util.encodeHtml(answer.Label));
            }
            else if (question.Answers && question.Answers.length == 1) {

                label.html(cafm.util.encodeHtml(question.Description));
            }

            // if the type is radio or checkbox set a field class and change label class (as label appears after control)
            if (cafm.enums.isSingleEnumValue(question.DataType, [qt.Checkbox, qt.RadioButton])) {

                // link label to control
                label.attr('for', answer.ID);

                if(question.Answers && question.Answers.length > 1) {
                    
                    wrap.addClass('cfFieldMulti');
                }

                label.removeClass('info-label');

                if (question.DataType === qt.Checkbox) {
                    wrap.append('&nbsp;');
                    label.addClass('k-checkbox-label');
                }
                if (question.DataType === qt.RadioButton) label.addClass('cfRadioLabel k-radio-label');

                wrap.append(label);
            }
            else {

                wrap.prepend(label);
            }

            return $('<div></div>').append(wrap).html();
        }
    },

    handlers: {

        checklistsDataBound: function (args) {
            /// <summary>Datbound handler for checklists</summary>
            /// <param name="args" type="Object">Event args object</param>
            
            var lvEl = args.sender.element;

            // checklist item click handler
            lvEl.off('click.cafm').on('click.cafm', '.cLvIt', function (e) {

                var item = $(e.currentTarget),
                    id = item.data('id'),
                    checklist = args.sender.dataSource.get(id);

                cafm.hd.checklist.render(checklist, lvEl, cafm.enums.ChecklistFormMode.Editable);
            });
        },
        checklistChanged: function (args) {
            /// <summary>Checklist changed handler - used for updating answers</summary>
            /// <param name="args" type="Object">Event args object</param>
            
            var checklist;
            if (args.sender.source) {

                checklist = args.sender.source;
            }
            else {

                checklist = args.sender;
            }

            switch (args.field) {

                case 'Questions':
                    {
                        var answer = args.items[0] ? args.items[0] : null,
                        question = answer ? answer.parent().parent() : null;

                        // edited a comment, don't carry on
                        if (cafm.hd.checklist.activeCommentTextArea) {
                            return;
                        }

                        // check there is a question and that the answer item 
                        // is actually an answer and not a comment question
                        if (!question || (answer && answer.Comments)) return;

                        // convert to plain JSON - otherwise problems arise on error
                        answer = answer.toJSON();

                        // if the question is of radio button type
                        if (question.DataType === cafm.enums.QuestionDataType.RadioButton) {

                            cafm.util.callFunctionAsync({

                                func: function (args) {

                                    // ensure answers are correctly true/false
                                    cafm.hd.checklist.helpers.ensureRadioOptions(question.Answers, answer.ID);

                                    // hide all secondary questions under the question
                                    $('li[data-id="{0}"]'.format(question.ID)).find('> .secondary-questions').hide();

                                    // if the answer has a secondary question
                                    if (answer.SecondaryQuestionID) {

                                        var sqItem = $('li[data-id="{0}"]'.format(answer.SecondaryQuestionID));
                                        sqItem.parent().show().children().hide();
                                        sqItem.show();
                                    }

                                    // send the checklist answer to the server
                                    cafm.hd.checklist.helpers.syncChecklistAnswer({
                                        checklist: checklist,
                                        answer: answer
                                    });
                                },
                                timeout: 10
                            });
                        }
                        else {

                            // ensure the decimal data type is always sent as a decimal
                            if (question.DataType == cafm.enums.QuestionDataType.Decimal && isInt(answer.Value)) {

                                answer.Value = answer.Value.toFixed(2);
                            }

                            // send the checklist answer to the server
                            cafm.hd.checklist.helpers.syncChecklistAnswer({
                                checklist: checklist,
                                answer: answer
                            });
                        }

                        break;
                    }
                case 'IsFailed':
                    {
                        if (checklist.IsFailed) {

                            cafm.hd.checklist.handlers.fail.open(checklist);
                        }
                        else {

                            cafm.hd.checklist.handlers.reopen.open(checklist);
                        }
                        break;
                    }

                case 'IsCompleted':
                    {
                        if (checklist.IsCompleted) {

                            cafm.hd.checklist.actions.completeChecklist(checklist);
                        }
                        break;
                    }
            }
        },
        commentChanged: function (args) {
            /// <summary>Comment changed handler</summary>
            /// <param name="args" type="Object">Event args object</param>

            var textArea = $(args.currentTarget),
                listItem = textArea.closest('li'),
                checklist = listItem.getParentViewModel(),
                question = cafm.hd.checklist.helpers.getChecklistQuestion(checklist, listItem.data('id'));

            if (!question) return;

            cafm.hd.checklist.helpers.ensureFormattedComments(question);

            // convert to plain JSON - otherwise problems arise on error
            question = question.toJSON();
            
            // send the question back to server
            cafm.hd.checklist.helpers.syncChecklistQuestion({
                checklist: checklist,
                question: question
            });
        },
        checklistMatrixDataBound: function (args) {
            /// <summary>Checklist matrix databound handler</summary>
            /// <param name="args" type="Object">Event args object</param>

            // handler to show checklist when a work order checklist status is clicked
            args.sender.element.off('click.cafm').on('click.cafm', '.matrixStatus', e => {
                let element = $(e.currentTarget);
                cafm.hd.checklist.helpers.getChecklist(element.data('id'), checklist => {
                    cafm.hd.checklist.render(checklist, element, cafm.enums.ChecklistFormMode.Admin);
                }, '#mainContentPane');
            });
            var noAssignees = $('.no-assignee');
            noAssignees.each(function (i, el) {

                var na = $(el);
                na.parent().addClass('no-assignee');
                na.remove();
            });
        },
        editComment: function (args) {
            /// <summary>Function to handle editing of a comment</summary>
            /// <param name="args" type="kendo.Observable">Event args object</param>

            var link = $(args.currentTarget),
                li = link.parents('.cLvIt:first'),
                checklist = li.getParentViewModel(),
                textArea = li.find('.commentTextArea:first'),
                question = cafm.util.find(checklist.Questions, function (question) {
                    return question.ID === li.data('id');
                });

            cafm.hd.checklist.activeCommentTextArea = textArea;

            if (!textArea.is(':visible') && !(checklist.IsCompleted || checklist.IsFailed)) {

                li.find('.commentWrapper:first').hide();
                textArea.show().find('textarea').focus();
            }
        },
        endEditComment: function (e) {
            /// <summary>Function to handle ending the editing of a comment</summary>
            /// <param name="args" type="kendo.Observable">Event args object</param>
            
            setTimeout(function () {
                
                var element = $(e.currentTarget),
                    li = element.parents('li:first'),
                    textArea = li.find('.commentTextArea:first'),
                    commentWrapper = li.find('.commentWrapper:first'),
                    checklist = li.getParentViewModel();

                var question = cafm.hd.checklist.helpers.getChecklistQuestion(checklist, li.data('id'));

                if (cafm.util.hasStringVal(question.Comments)) {

                    li.addClass('hasComment');
                    commentWrapper.show();
                }
                else {

                    li.removeClass('hasComment');
                    commentWrapper.hide();
                }

                textArea.hide();
            }, 250);
        },
        fail: {

            cancel: function () {
                /// <summary>Cancel button handler for reopen and fail actions</summary>
                
                cafm.hd.checklist.currentChecklist.IsFailed = !cafm.hd.checklist.currentChecklist.IsFailed;
                cafm.hd.checklist.currentForm.find('.isfailed-field [type=Checkbox]').setChecked(cafm.hd.checklist.currentChecklist.IsFailed, true);
                cafm.toolbar.standardActionToolbar.cancel();
            },
            failchecklist(e) {
                /// <summary>Fail checklist button handler</summary>

                var button = $(e.currentTarget),
                    viewModel = button.getParentViewModel() || cafm.views.getActiveActionWindowViewModel(),
                    containerId = isMobile ? button.closest(`.${cafm.res.consts.CssClass_ActionPanel}`).attr("id") : button.closest(".k-window").find(`.${cafm.res.consts.CssClass_ActionPanel}`).attr("id");
                
                viewModel.ActionDateTime = cafm.web.funcs.getNowUTC();

                cafm.hd.addSyncAction((syncId) => {
                    cafm.hd.callSyncAction({
                        url: cafm.url.api('WorkOrder/FailChecklist'),
                        values: viewModel,
                        syncId: syncId,
                        syncWorkOrder(workOrder) {
                            cafm.hd.checklist.helpers.syncWorkOrderChecklist({
                                checklistId: viewModel.ChildID.ID,
                                responseWorkOrder: workOrder
                            });
                        },
                        elementId: containerId,
                        preventValidate: false,
                        preventDirty: isMobile,
                        loaderSelector: `#${containerId}, .btn[data-key="FailChecklist"]`,
                        success: cafm.hd.checklist.handlers.fail.success,
                        fallback() {
                            cafm.hd.checklist.handlers.fail.fallback(e)
                        },
                        error: cafm.hd.checklist.handlers.fail.error,
                        offlineActionType: cafm.enums.OfflineActionType.FailChecklist,
                    });
                }, viewModel.ChildID.ID);
            },
            fallback(e) {

                let button = $(e.currentTarget),
                    viewModel = button.getParentViewModel() || cafm.views.getActionWindowViewModel(),
                    checklist = cafm.hd.checklist.helpers.getChecklistFromWorkOrder(viewModel.ChildID.ID);

                if (checklist) {

                    cafm.hd.checklist.helpers.setComment(checklist, viewModel.Comments);

                    checklist.Status = cafm.enums.ChecklistStatus.Failed;
                    checklist.IsFailed = true;
                    if (checklist.IsCompleted === true) checklist.IsCompleted = false;
                    cafm.hd.checklist.helpers.setChecklistStatusDescription(checklist);
                    cafm.hd.checklist.helpers.setChecklistCompletionStage(checklist);

                    // set flags to block relevant actions
                    // and refresh messages
                    if (checklist.CompletionStage == cafm.enums.ChecklistCompletionStage.OnStartWorkOrder)
                    {
                        cafm.hd.workOrder.WillFailedChecklistsPreventStart = true;
                    }

                    if (checklist.CompletionStage == cafm.enums.ChecklistCompletionStage.OnAcceptWorkOrder)
                    {
                        cafm.hd.workOrder.WillFailedChecklistsPreventAccept = true;
                    }

                    if (checklist.CompletionStage == cafm.enums.ChecklistCompletionStage.OnResolveCompleteWorkOrder)
                    {
                        cafm.hd.workOrder.WillFailedChecklistsPreventResolveOrComplete = true;
                    }

                    cafm.hd.checklist.helpers.refreshFailedChecklistMessage(checklist.CompletionStage);
                    cafm.hd.checklist.helpers.refreshIncompleteQuestionsMessage(checklist.CompletionStage);

                    // if checklist is for an asset then set its ChecklistStatus to Failed
                    if (cafm.hd.checklist.helpers.isActiveChecklistForAsset()) {
                        let asset = cafm.assets.getWorkOrderAsset(checklist.InheritedHostId);
                        if (asset)
                            asset.ChecklistStatus = cafm.enums.ChecklistStatus.Failed;
                    }

                    // end the offline action (caches work order)
                    hdActions.helpers.endOfflineAction({
                        cacheWorkOrder: true,
                        preventCloseWindow: true
                    });
                }

                cafm.hd.checklist.handlers.fail.success();
            },
            open: function (checklist) {
                /// <summary>Handler for opening the fail checklist action window</summary>
                /// <param name="checklist" type="Object">The checklist to fail</param>

                cafm.views.openChildActionWindow({

                    action: 'Helpdesk/FailChecklist',
                    height: cafm.views.actionWindowConfig.smallMedium.height(),
                    winOptions: { actions: [] },
                    viewModel: cafm.util.createParentChildId(cafm.hd.workOrder.ID, checklist.ID)
                });
            },
            success: function () {
                /// <summary>Fail action success handler</summary>
                
                cafm.hd.checklist.currentForm.find('.checklistBack').click();

                // close straight away if not an asset checklist
                if (!cafm.hd.checklist.helpers.isActiveChecklistForAsset() || !isMobile)
                    cafm.views.closeActionWindow();
            },
            error: function () {
                /// <summary>Fail action error handler</summary>

                cafm.hd.checklist.handlers.fail.updateUi(false);
            },
            updateUi: function (failed) {
                /// <summary>Update ui helper for handlers</summary>
                /// <param name="failed" type="Boolean">The checklist failed flag</param>

                cafm.hd.checklist.currentForm.enableControls(!failed);

                var commentLinks = cafm.hd.checklist.currentForm.find('li:not(.hasComment) .commentLink,.commentEditLink'),
                    status = failed ? cafm.res.str.LabelFailed : cafm.res.str.LabelNotCompleted;

                cafm.hd.checklist.currentForm.find('.checklist-status').text(status);

                if(failed){

                    commentLinks.hide();
                }
                else {

                    commentLinks.show();
                }
            }
        },
        reopen: {

            cancel: function () {
                /// <summary>Reopen action cancel button handler</summary>

                cafm.hd.checklist.handlers.fail.cancel();
            },
            fallback(e) {

                let button = $(e.currentTarget),
                    viewModel = button.getParentViewModel() || cafm.views.getActionWindowViewModel(),
                    checklist = cafm.hd.checklist.helpers.getChecklistFromWorkOrder(viewModel.ChildID.ID);

                if (checklist) {

                    cafm.hd.checklist.helpers.setComment(checklist, viewModel.Comments);

                    checklist.Status = cafm.enums.ChecklistStatus.Incomplete;
                    checklist.IsFailed = false;
                    cafm.hd.checklist.helpers.setChecklistStatusDescription(checklist);
                    cafm.hd.checklist.helpers.setChecklistCompletionStage(checklist);

                    // set flag to block resolving or completing the work order
                    cafm.hd.workOrder.WillFailedChecklistsPreventResolveOrComplete = cafm.hd.checklist.helpers.hasFailedChecklist(cafm.enums.ChecklistCompletionStage.OnResolveCompleteWorkOrder);
                    cafm.hd.workOrder.WillFailedChecklistsPreventAccept = cafm.hd.checklist.helpers.hasFailedChecklist(cafm.enums.ChecklistCompletionStage.OnAcceptWorkOrder);
                    cafm.hd.workOrder.WillFailedChecklistsPreventStart = cafm.hd.checklist.helpers.hasFailedChecklist(cafm.enums.ChecklistCompletionStage.OnStartWorkOrder);

                    // refresh messages
                    cafm.hd.checklist.helpers.refreshFailedChecklistMessage(checklist.CompletionStage);
                    cafm.hd.checklist.helpers.refreshIncompleteQuestionsMessage(checklist.CompletionStage);

                    // if checklist is for an asset then reset its ChecklistStatus
                    if (cafm.hd.checklist.helpers.isActiveChecklistForAsset()) {
                        let failedChecklists = cafm.util.whereByFieldValue(cafm.hd.checklist.helpers.getFailedChecklists(checklist.CompletionStage), "InheritedHostId", checklist.InheritedHostId);
                        let asset = cafm.assets.getWorkOrderAsset(checklist.InheritedHostId);
                        if (asset)
                            asset.ChecklistStatus = cafm.util.hasItem(failedChecklists) ? cafm.enums.ChecklistStatus.Failed :
                                (!cafm.util.exists(asset.Checklists, c => c.ID != checklist.ID && c.Status == cafm.enums.ChecklistStatus.Incomplete) ?
                                cafm.enums.ChecklistStatus.Complete : cafm.enums.ChecklistStatus.Incomplete);
                    }

                    // end the offline action (caches work order)
                    hdActions.helpers.endOfflineAction({
                        cacheWorkOrder: true,
                        preventCloseWindow: true
                    });
                }

                cafm.hd.checklist.handlers.fail.success();
            },
            reopenchecklist(e) {
                /// <summary>Reopen button handler</summary>
                
                let button = $(e.currentTarget),
                    viewModel = button.getParentViewModel() || cafm.views.getActiveActionWindowViewModel(),
                    containerId = isMobile ? button.closest(`.${cafm.res.consts.CssClass_ActionPanel}`).attr("id") : button.closest(".k-window").find(`.${cafm.res.consts.CssClass_ActionPanel}`).attr("id");
                viewModel.ActionDateTime = cafm.web.funcs.getNowUTC();

                cafm.hd.addSyncAction((syncId) => {
                    cafm.hd.callSyncAction({
                        url: cafm.url.api('WorkOrder/ReopenChecklist'),
                        values: viewModel,
                        syncId: syncId,
                        syncWorkOrder(workOrder) {
                            cafm.hd.checklist.helpers.syncWorkOrderChecklist({
                                checklistId: viewModel.ChildID.ID,
                                responseWorkOrder: workOrder
                            });
                        },
                        elementId: containerId,
                        preventValidate: false,
                        preventDirty: isMobile,
                        loaderSelector: `#${containerId}, .btn[data-key="ReopenChecklist"]`,
                        success: cafm.hd.checklist.handlers.fail.success,
                        fallback() {
                            cafm.hd.checklist.handlers.reopen.fallback(e);
                        },
                        error: cafm.hd.checklist.handlers.reopen.error,
                        offlineActionType: cafm.enums.OfflineActionType.ReopenChecklist
                    });
                }, viewModel.ChildID.ID);
            },
            open: function (checklist) {
                /// <summary>Handler for opening the reopen checklist action window</summary>
                /// <param name="checklist" type="Object">The checklist to reopen</param>

                cafm.views.openChildActionWindow({

                    action: 'Helpdesk/ReopenChecklist',
                    height: cafm.views.actionWindowConfig.smallMedium.height(),
                    winOptions: { actions: [] },
                    viewModel: cafm.util.createParentChildId(cafm.hd.workOrder.ID, checklist.ID)
                });
            },
            error: function () {
                /// <summary>Reopen action error handler</summary>

                cafm.hd.checklist.handlers.fail.updateUi(true);
            }
        }
    },
    helpers: {

        checklistMatrixStatus: function (data, fieldName) {
            /// <summary>Function to render a checklist matrix answer</summary>
            /// <param name="data" type="Object">The grid data item</param>
            /// <param name="fieldName" type="String">The field name</param>

            var woc = data[fieldName];

            if (!woc && fieldName == cafm.res.consts.FieldName_SharedChecklistAssignedToID) woc = data[fieldName];

            if (woc) {

                var link = $('<a/>', {

                    'class': 'matrixStatus',
                    'data-id': woc.ID
                });

                link.text(woc.StatusDescription);

                return $('<div/>').append(link).html();
            }
            else {

                return '<span class="no-assignee"></span>';
            }
        },
        checklistPanelBarLoad: function (clientId) {
            /// <summary>Function to be called once the checklist matrix panel bar has loaded</summary>
            /// <param name="clientId" type="String">The panel bar client ID</param>

            setTimeout(function () {

                $('#' + clientId).find('.k-header').first().click();
            }, 250);
        },
        ensureFormattedComments: function (item) {

            // format the comments into formatted comments for display as HTML with line breaks
            if (item.Comments) {

                item.set('FormattedComments', cafm.util.toSafeHtml(item.Comments));
            }
            else {

                item.set('FormattedComments', null);
            }
        },
        ensureRadioOptions: function(answers, selectedId) {

            // ensure answers are correctly true/false
            answers.forEach(function (a) {

                a.Value = a.ID == selectedId;
            });
        },
        getChecklistAnswer: function (checklist, questionId, answerId) {
            /// <summary>Function to get a checklist answer, also looks with secondary questions</summary>
            /// <param name="checklist" type="Object">The checklist object to get the question from</param>
            /// <param name="questionId" type="String">The question ID</param>
            /// <param name="answerId" type="String">The answer ID</param>
            /// <returns type="Object">The answer object</returns>

            var question = cafm.hd.checklist.helpers.getChecklistQuestion(checklist, questionId);

            if (question && question.Answers) {

                return cafm.util.findByFieldValue(question.Answers, 'ID', answerId);
            }
            else {

                return null;
            }
        },
        getChecklist(checklistId, callback, loaderSelector) {
            cafm.actions.execute({
                url: cafm.url.api('WorkOrder/GetChecklist'),
                values: cafm.util.createParentChildId(cafm.hd.workOrder.ID, checklistId),
                loaderSelector: loaderSelector,
                success: callback
            });
        },
        getChecklistFromWorkOrder: function (checklistId, workOrder) {
        
            let acs, rcs;

            if(workOrder) {
                acs = workOrder.ActionChecklists;
                rcs = workOrder.RiskAssessmentChecklists;
            }
            else {
                acs = cafm.hd.checklist.getWorkOrderActionChecklists();
                rcs = cafm.hd.checklist.getWorkOrderRiskAssessmentChecklists();
            }

            let match = cafm.util.findByFieldValue(acs, 'ID', checklistId);
            if (!match) match = cafm.util.findByFieldValue(rcs, 'ID', checklistId);
            if (!match) match = cafm.assets.getWorkOrderAssetChecklist(checklistId);
            return match;
        },
        getChecklistQuestion: function (checklist, questionId) {
            /// <summary>Function to get a checklist question, also looks for secondary questions</summary>
            /// <param name="checklist" type="Object">The checklist object to get the question from</param>
            /// <param name="questionId" type="String">The question ID</param>
            /// <returns type="Object">The question object</returns>
            
            // try to get question at the top level
            var question = cafm.util.find(checklist.Questions, function (q) {

                return q.ID === questionId;
            });

            if (question) return question;

            // function called recursively to get nested secondary question from answer
            var matchSecondaryQuestion = function (a) {

                var sq = a.SecondaryQuestion;
                if (sq) {

                    if (sq.ID == questionId) {

                        return sq;
                    }
                    else if (cafm.util.hasItem(sq.Answers)) {

                        var match;
                        sq.Answers.forEach(function (a2) {

                            if (!match) {
                                match = matchSecondaryQuestion(a2);
                            }
                        });

                        return match;
                    }
                }
                
                return null;
            }

            // check the answers of each question
            checklist.Questions.forEach(function (q) {

                if (!question && q.Answers) {

                    q.Answers.forEach(function (a) {

                        // have we already got a match
                        if (!question) {
                            // get the secondary question
                            question = matchSecondaryQuestion(a);
                        }
                    })
                }
            })

            return question;
        },
        getChecklists: function () {
            /// <summary>Function to get all checklists for the current assignment</summary>
            /// <returns type="Array">Array of all checklists for the current assignment</returns>

            var checklists = [],
                acs = cafm.hd.checklist.getWorkOrderActionChecklists(),
                rcs = cafm.hd.checklist.getWorkOrderRiskAssessmentChecklists(),
                ascs = cafm.assets.getAllWorkOrderAssetChecklists();
            if (acs && acs.toJSON) acs = acs.toJSON();
            if (rcs && rcs.toJSON) rcs = rcs.toJSON();
            if (ascs && ascs.toJSON) ascs = ascs.toJSON();
            cafm.util.addAll(checklists, acs);
            cafm.util.addAll(checklists, rcs);
            cafm.util.addAll(checklists, ascs);
            return checklists;
        },
        getFailedChecklists: function (stage) {
            /// <summary>Function to get failed checklists for the current assignment</summary>
            /// <returns type="Array">Array of failed checklist for the current assignment</returns>

            return cafm.util.where(cafm.hd.checklist.helpers.getChecklists(), (c) => { return c.CompletionStage==stage && c.IsFailed === true });
        },
        getIncompleteMandatoryChecklists: function (stage) {
            /// <summary>Function to get incomplete mandatory checklists for the current assignment</summary>
            /// <returns type="Array">Array of incomplete mandatory checklist for the current assignment</returns>

            return cafm.util.where(cafm.hd.checklist.helpers.getChecklists(), (c) => { return c.IsMandatory && c.CompletionStage == stage && c.IsCompleted === false });
        },
        hasIncompleteMandatoryChecklist: function (stage) {
            /// <summary>Function to check for incomplete mandatory checklists for the current assignment</summary>
            /// <returns type="Boolean">True if there is a failed checklist for the current assignment</returns>

            return cafm.util.hasItem(cafm.hd.checklist.helpers.getIncompleteMandatoryChecklists(stage));
        },
        hasFailedChecklist: function (stage) {
            /// <summary>Function to check for failed checklists across all assignments on the work order</summary>
            /// <returns type="Boolean">True if there is a failed checklist for the current assignment</returns>
            if (stage == cafm.enums.ChecklistCompletionStage.OnResolveCompleteWorkOrder && cafm.hd.workOrder.HasFailedChecklistsNotAssignedToForResolveCompleteAction) { return true; }
            if (stage == cafm.enums.ChecklistCompletionStage.OnAcceptWorkOrder && cafm.hd.workOrder.HasFailedChecklistsNotAssignedToForAcceptAction) { return true; }
            if (stage == cafm.enums.ChecklistCompletionStage.OnStartWorkOrder && cafm.hd.workOrder.HasFailedChecklistsNotAssignedToForStartAction) { return true; }
            return cafm.util.hasItem(cafm.hd.checklist.helpers.getFailedChecklists(stage));
        },
        isActiveChecklistForAsset() {
            return $(".asset-checklist-tabs").length > 0;
        },
        isChecklistComplete: function (checklist) {
            /// <summary>Function to check for unanswered checklist questions</summary>
            /// <param name="checklist" type="Object">The checklist object</param>
            /// <returns type="Boolean">True if the checklist is complete</returns>

            var isNotComplete = false;

            // function called recursively to check nested secondary questions of answers
            var checkQuestion = function (q) {
                
                if (q.Answers) {

                    if (q.DataType === cafm.enums.QuestionDataType.RadioButton && !cafm.util.exists(q.Answers, function (a) { return !isNullOrUndefined(a.Value) && a.Value !== false })) {

                        isNotComplete = true;
                    }

                    if (!isNotComplete) {

                        q.Answers.forEach(function (a) {

                            if (q.DataType !== cafm.enums.QuestionDataType.RadioButton && !a.Value) {

                                isNotComplete = true;
                            }

                            // have we already got a match
                            if (a.Value == true && a.SecondaryQuestion) {

                                // check the secondary question
                                checkQuestion(a.SecondaryQuestion);
                            }
                        });
                    }
                }
            }

            // check the answers of each question and sub-questions
            checklist.Questions.forEach(function (q) {

                if(!isNotComplete)
                    checkQuestion(q);
            })

            return !isNotComplete;
        },
        removeWorkOrderViewKeys: function () {
            /// <summary>Function to remove work order view keys - allowing the views to be refreshed on next view</summary>

            cafm.hd.removeTabLoadKey(cafm.res.consts.DataKey_HelpdeskActionChecklists);
            cafm.hd.removeTabLoadKey(cafm.res.consts.DataKey_HelpdeskAdminChecklists);
            cafm.hd.removeTabLoadKey(cafm.res.consts.DataKey_HelpdeskRiskAssessmentChecklists);
        },

        refreshFailedChecklistMessage: function (stage) {

            var wo = cafm.hd.workOrder, cks = cafm.hd.checklist.helpers.getFailedChecklists(stage);
            if (cks.length > 0) {

                var msgs = [];

                cks.forEach(function (ck) {
                    msgs.push(cafm.res.str.Template0AssignedTo1.format(ck.Description, ck.AssignedTo));
                });

                var appendMsgs = msgs.join('\r\n');
                switch (stage)
                {
                    case cafm.enums.ChecklistCompletionStage.OnStartWorkOrder:
                        wo.StartFailureMessageDueToFailedChecklist = wo.StartFailureMessageDueToFailedChecklistNotAssignedTo + appendMsgs;
                        break;
                    case cafm.enums.ChecklistCompletionStage.OnAcceptWorkOrder:
                        wo.AcceptFailureMessageDueToFailedChecklist = wo.AcceptFailureMessageDueToFailedChecklistNotAssignedTo + appendMsgs;
                        break;
                    case cafm.enums.ChecklistCompletionStage.OnResolveCompleteWorkOrder:
                        wo.CompleteFailureMessageDueToFailedChecklist = wo.CompleteFailureMessageDueToFailedChecklistNotAssignedTo + appendMsgs;
                        wo.ResolveFailureMessageDueToFailedChecklist = wo.ResolveFailureMessageDueToFailedChecklistNotAssignedTo + appendMsgs;
                        break;
                }
            }
            else
            {
                switch (stage) {
                    case cafm.enums.ChecklistCompletionStage.OnStartWorkOrder:
                        wo.StartFailureMessageDueToFailedChecklist = wo.StartFailureMessageDueToFailedChecklistNotAssignedTo;
                        break;
                    case cafm.enums.ChecklistCompletionStage.OnAcceptWorkOrder:
                        wo.AcceptFailureMessageDueToFailedChecklist = wo.AcceptFailureMessageDueToFailedChecklistNotAssignedTo;
                        break;
                    case cafm.enums.ChecklistCompletionStage.OnResolveCompleteWorkOrder:
                        wo.CompleteFailureMessageDueToFailedChecklist = wo.CompleteFailureMessageDueToFailedChecklistNotAssignedTo;
                        wo.ResolveFailureMessageDueToFailedChecklist = wo.ResolveFailureMessageDueToFailedChecklistNotAssignedTo;
                        break;
                }
            }
        },
        refreshIncompleteQuestionsMessage: function (stage) {

            var wo = cafm.hd.workOrder;
            if (cafm.hd.checklist.helpers.hasIncompleteMandatoryChecklist(stage)) {

                var cks = cafm.hd.checklist.helpers.getIncompleteMandatoryChecklists(stage),
                    msgs = [];

                cks.forEach(function (ck) {
                    msgs.push(cafm.res.str.Template0AssignedTo1.format(ck.Description, ck.AssignedTo));
                });

                var appendMsgs = msgs.join('\r\n');

                switch (stage) {
                    case cafm.enums.ChecklistCompletionStage.OnStartWorkOrder:
                        wo.StartFailureMessageDueToIncompleteChecklist = wo.StartFailureMessageDueToIncompleteChecklistNotAssignedTo + appendMsgs;
                        break;
                    case cafm.enums.ChecklistCompletionStage.OnAcceptWorkOrder:
                        wo.AcceptFailureMessageDueToIncompleteChecklist = wo.AcceptFailureMessageDueToIncompleteChecklistNotAssignedTo + appendMsgs;
                        break;
                    case cafm.enums.ChecklistCompletionStage.OnResolveCompleteWorkOrder:
                        wo.CompleteFailureMessageDueToIncompleteChecklist = wo.CompleteFailureMessageDueToIncompleteChecklistNotAssignedTo + appendMsgs;
                        wo.ResolveFailureMessageDueToIncompleteChecklist = wo.ResolveFailureMessageDueToIncompleteChecklistNotAssignedTo + appendMsgs;        
                        break;
                }
                
            }
            else {
                switch (stage) {
                    case cafm.enums.ChecklistCompletionStage.OnStartWorkOrder:
                        wo.StartFailureMessageDueToIncompleteChecklist = wo.StartFailureMessageDueToIncompleteChecklistNotAssignedTo;
                        break;
                    case cafm.enums.ChecklistCompletionStage.OnAcceptWorkOrder:
                        wo.AcceptFailureMessageDueToIncompleteChecklist = wo.AcceptFailureMessageDueToIncompleteChecklistNotAssignedTo;
                        break;
                    case cafm.enums.ChecklistCompletionStage.OnResolveCompleteWorkOrder:
                        wo.CompleteFailureMessageDueToIncompleteChecklist = wo.CompleteFailureMessageDueToIncompleteChecklistNotAssignedTo;
                        wo.ResolveFailureMessageDueToIncompleteChecklist = wo.ResolveFailureMessageDueToIncompleteChecklistNotAssignedTo;        
                        break;
                }
            }
        },
        
        setChecklistStatusDescription: function (checklist) {

            checklist.statusDescription = checklist.IsCompleted ? cafm.res.str.LabelCompleted : (checklist.IsFailed ? cafm.res.str.LabelFailed : cafm.res.str.LabelNotCompleted);            
        },
        setChecklistCompletionStage: function (checklist) {

            var completionStageText = "";

            switch (checklist.CompletionStage) {
                case cafm.enums.ChecklistCompletionStage.OnStartWorkOrder:
                    completionStageText = "[Start]";
                    break;
                case cafm.enums.ChecklistCompletionStage.OnAcceptWorkOrder:
                    completionStageText = "[Accept]"
                    break;
                case cafm.enums.ChecklistCompletionStage.OnResolveCompleteWorkOrder:
                    completionStageText = "[Resolve/Complete]";
                    break;
            }

            checklist.completionStage = completionStageText + ",";
        },
        setComment: function (checklist, comments) {

            if (comments) {

                var cmts = checklist.Comments,
                    isShared = checklist.Scope == cafm.enums.CheckListScope.Shared,
                    temp = isShared ? cafm.res.str.TemplateChecklistStatusChangedBy : cafm.res.str.TemplateChecklistStatusChanged,
                    actLbl = checklist.IsFailed ? cafm.res.str.LabelIncomplete : cafm.res.str.LabelFailed,
                    datLbl = cafm.util.toDateString(new Date(), 'g');

                if (cmts)
                    cmts += '\r\n';

                cmts += isShared ?
                    temp.format(actLbl, datLbl, cafm.auth.personName(), comments) : temp.format(actLbl, datLbl, comments);

                checklist.Comments = cmts;
                checklist.HasComment = cafm.util.hasStringVal(cmts);
            }
        },
        syncChecklistAnswer: function (args) {
            /// <summary>Function to send an answer to the server</summary>
            /// <param name="args" type="Object">The syc args object</param>
            
            if (cafm.hd.checklist.sendAnswers) {

                cafm.hd.addSyncAction(function (syncId) {

                    cafm.hd.callSyncAction({
                        url: cafm.url.api('WorkOrder/UpdateChecklistAnswer'),
                        values: {
                            _key: args.answer.ID,
                            Answer: args.answer,
                            ChecklistID: args.checklist.ID,
                            WorkOrderID: cafm.actions.getObjectInContextId()
                        },
                        syncId: syncId,
                        syncWorkOrder: function (workOrder) {

                            cafm.hd.checklist.helpers.syncWorkOrderAnswer({
                                checklistId: args.checklist.ID,
                                answer: args.answer,
                                responseWorkOrder: workOrder
                            });
                        },
                        preventDirty: isMobile,
                        offlineActionType: cafm.enums.OfflineActionType.UpdateChecklistAnswer,
                        fallback: function () {

                            var checklist = cafm.hd.checklist.helpers.getChecklistFromWorkOrder(args.checklist.ID),
                                answer = cafm.hd.checklist.helpers.getChecklistAnswer(cafm.hd.checklist.helpers.getChecklistFromWorkOrder(args.checklist.ID), args.answer.QuestionID, args.answer.ID);

                            if(answer) {

                                var v = args.answer.Value;

                                // if it's a date, serialise to ISO date string
                                if (isDate(v)) v = cafm.util.toIsoDateString(v);

                                // set cached answer value
                                answer.Value = v;

                                // set the is completed flag, status and description
                                if(cafm.hd.checklist.helpers.isChecklistComplete(checklist)) {

                                    checklist.IsCompleted = true;
                                    checklist.Status = cafm.enums.ChecklistStatus.Complete;
                                }
                                else {

                                    checklist.IsCompleted = false;
                                    checklist.Status = cafm.enums.ChecklistStatus.Incomplete;
                                }
                                
                                // if checklist is for an asset then set ChecklistStatus to Complete or Incomplete as applicable
                                if (cafm.hd.checklist.helpers.isActiveChecklistForAsset()) {                                                                        
                                    let asset = cafm.assets.getWorkOrderAsset(checklist.InheritedHostId);
                                    if (asset) {
                                        if (cafm.util.exists(asset.Checklists, c => c.ID != checklist.ID && c.Status == cafm.enums.ChecklistStatus.Failed)) {
                                            asset.ChecklistStatus = cafm.enums.ChecklistStatus.Failed;
                                        }
                                        else {
                                            asset.ChecklistStatus =
                                                checklist.IsCompleted === true &&
                                                    !cafm.util.exists(asset.Checklists, c => c.ID != checklist.ID && c.Status == cafm.enums.ChecklistStatus.Incomplete) ?
                                                    cafm.enums.ChecklistStatus.Complete : cafm.enums.ChecklistStatus.Incomplete;
                                        }
                                    }
                                }

                                cafm.hd.checklist.helpers.setChecklistStatusDescription(checklist);
                                cafm.hd.checklist.helpers.setChecklistCompletionStage(checklist);

                                // set flag to block resolving or completing the work order
                                var wo = cafm.hd.workOrder;
                                wo.WillUnansweredChecklistsPreventResolveOrComplete =
                                    cafm.hd.checklist.helpers.hasIncompleteMandatoryChecklist(cafm.enums.ChecklistCompletionStage.OnResolveCompleteWorkOrder) || // don't allow incomplete mandatory for current assignment
                                (wo.HasUnansweredMandatoryChecklistsNotAssignedToForResolveCompleteAction && 
                                        !(cafm.getClientSettings().helpdeskSettings.principalCanCompleteWithUnansweredQuestions && cafm.hd.helpers.isPrincipalOrTeamLeadForWorkOrder(wo))); // don't allow incomplete mandatory for other assignment and if current user is not team lead or principal


                                wo.WillUnansweredChecklistsPreventStart =
                                    cafm.hd.checklist.helpers.hasIncompleteMandatoryChecklist(cafm.enums.ChecklistCompletionStage.OnStartWorkOrder) || // don't allow incomplete mandatory for current assignment
                                (wo.HasUnansweredMandatoryChecklistsNotAssignedToForStartAction &&
                                        !(cafm.getClientSettings().helpdeskSettings.principalCanCompleteWithUnansweredQuestions && cafm.hd.helpers.isPrincipalOrTeamLeadForWorkOrder(wo))); // don't allow incomplete mandatory for other assignment and if current user is not team lead or principal

                                wo.WillUnansweredChecklistsPreventAccept =
                                    cafm.hd.checklist.helpers.hasIncompleteMandatoryChecklist(cafm.enums.ChecklistCompletionStage.OnAcceptWorkOrder) || // don't allow incomplete mandatory for current assignment
                                (wo.HasUnansweredMandatoryChecklistsNotAssignedToForAcceptAction); // don't allow incomplete mandatory for contractor


                                // refresh messages
                                cafm.hd.checklist.helpers.refreshIncompleteQuestionsMessage(cafm.enums.ChecklistCompletionStage.OnAcceptWorkOrder);
                                cafm.hd.checklist.helpers.refreshIncompleteQuestionsMessage(cafm.enums.ChecklistCompletionStage.OnStartWorkOrder);
                                cafm.hd.checklist.helpers.refreshIncompleteQuestionsMessage(cafm.enums.ChecklistCompletionStage.OnResolveCompleteWorkOrder);

                                // end the offline action (caches work order)
                                hdActions.helpers.endOfflineAction({
                                    cacheWorkOrder: true,
                                    preventCloseWindow: true
                                });
                            }
                        }
                    });
                }, args.answer.ID, 500);
            }
        },
        syncChecklistQuestion: function (args) {
            /// <summary>Function to send a question to the server</summary>
            /// <param name="args" type="Object">The syc args object</param>


            if (cafm.hd.checklist.sendQuestions) {
                
                cafm.hd.addSyncAction(function (syncId) {

                    cafm.hd.checklist.activeCommentTextArea = null;

                    cafm.hd.callSyncAction({
                        url: cafm.url.api('WorkOrder/UpdateChecklistQuestion'),
                        values: {
                            _key: args.question.ID,
                            Question: args.question,
                            ChecklistID: args.checklist.ID,
                            WorkOrderID: cafm.actions.getObjectInContextId()
                        },
                        syncId: syncId,
                        syncWorkOrder: function (workOrder) {

                            cafm.hd.checklist.helpers.syncWorkOrderQuestion({
                                checklistId: args.checklist.ID,
                                question: args.question,
                                responseWorkOrder: workOrder
                            });
                        },
                        preventDirty: isMobile,
                        offlineActionType: cafm.enums.OfflineActionType.UpdateChecklistQuestion,
                        fallback: function () {

                            var question = cafm.hd.checklist.helpers.getChecklistQuestion(cafm.hd.checklist.helpers.getChecklistFromWorkOrder(args.checklist.ID), args.question.ID);

                            if (question) {

                                question.Comments = args.question.Comments;
                                question.HasComment = cafm.util.hasStringVal(args.question.Comments);
                            }

                            // end the offline action (caches work order)
                            hdActions.helpers.endOfflineAction({
                                cacheWorkOrder: true,
                                preventCloseWindow: true
                            });
                        }
                    });
                }, args.question.ID, 500);
            }
        },
        syncWorkOrderAnswer: function (args) {

            cafm.util.syncClientServerObjects(cafm.hd.workOrder, args.responseWorkOrder);
            cafm.hd.checklist.helpers.setChecklistStatusDescription(cafm.hd.checklist.helpers.getChecklistFromWorkOrder(args.checklistId));

            // cache the work order, as we have the up-to-date copy from response
            if (args.responseWorkOrder.IsCacheable) {
                // this sets the updated work order in the cache
                cafm.hd.workOrderCachingHandler.cacheWorkOrderInContext();
            }
        },
        syncWorkOrderChecklist: function (args) {

            cafm.util.syncClientServerObjects(cafm.hd.workOrder, args.responseWorkOrder);
            let checklist = cafm.hd.checklist.helpers.getChecklistFromWorkOrder(args.checklistId);
            let cb = (cl) => {
                cafm.hd.checklist.helpers.setChecklistStatusDescription(cl);
                // cache the work order, as we have the up-to-date copy from response
                if (args.responseWorkOrder.IsCacheable) {
                    // this sets the updated work order in the cache
                    cafm.hd.workOrderCachingHandler.cacheWorkOrderInContext();
                }
            }
            if (checklist) {
                cb(checklist);
            }
            else if (cafm.hd.helpers.isHelpdeskOperator()) { // allow HD operator to get from server, as they won't have the checklist on the client           
                cafm.hd.checklist.helpers.getChecklist(args.checklistId, cb);
            }
        },
        syncWorkOrderQuestion: function (args) {
            
            cafm.util.syncClientServerObjects(cafm.hd.workOrder, args.responseWorkOrder);
            var checklist = cafm.hd.checklist.helpers.getChecklistFromWorkOrder(args.checklistId);
            cafm.hd.checklist.helpers.ensureFormattedComments(cafm.hd.checklist.helpers.getChecklistQuestion(checklist, args.question.ID));

            // cache the work order, as we have the up-to-date copy from response
            if (args.responseWorkOrder.IsCacheable) {
                // this sets the updated work order in the cache
                cafm.hd.workOrderCachingHandler.cacheWorkOrderInContext();
            }
        }
    }
}